module.exports = __webpack_public_path__ + "static/media/Book.5025fa5f.png";